import { createAction } from 'redux-actions';

export const resetHouseholdMemberForm = createAction(
  'RESET_HOUSEHOLD_MEMBER_FORM'
);
